import cn from 'classnames';
import { UseFormRegister } from 'react-hook-form';
import AlertIcon from 'shared/icons/alert.svg';
import { FormValues } from '../types';
import { Checkbox } from './checkbox';
import styles from './form-footer.module.scss';

type FormFooterProps = {
  error: boolean;
  register: UseFormRegister<FormValues>;
  toggleAgreementDrawer: () => void;
};

export const FormFooter = ({ error, register, toggleAgreementDrawer }: FormFooterProps) => {
  const handleClick: React.MouseEventHandler<HTMLSpanElement> = (e) => {
    e.preventDefault();
    toggleAgreementDrawer();
  };

  return (
    <div className={styles.footer}>
      <div className={cn(styles.errorMessage, { [styles.errorMessage__visible]: error })}>
        <img src={AlertIcon} alt="" width={20} height={20} style={{ flexShrink: 0 }} />
        Для отправки анкеты необходимо заполнить поля и дать согласие на обработку данных
      </div>
      <div className={styles.submitSection}>
        <Checkbox tabIndex={17} id="checkbox-consent" {...register('personalDataConsent')}>
          Даю{' '}
          <span className={styles.agreementLink} onClick={handleClick}>
            согласие
          </span>{' '}
          на обработку моих персональных данных
        </Checkbox>
        <button className={styles.submitButton} tabIndex={18} type="submit">
          Отправить
        </button>
      </div>
    </div>
  );
};
